import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/** The step that explains the run's current status — `null` only for a run finished in success. */
export type FacilityWorkflowRunFocusStepPayload = {
	readonly id: number;
	readonly position: number;
	readonly label: string;
	readonly status: LabeledValuePayload;
	readonly isStalled: boolean;
};

/**
 * One row of the supervision list, exactly as `WorkflowRunListSerializer` renders it. `subject`,
 * `beneficiary` (null outside a beneficiary dossier) and `interview` are relations, `{ id }` only: the
 * name is resolved from the directories, never sent inline here.
 */
export type FacilityWorkflowRunPayload = {
	readonly id: number;
	readonly subject: { readonly id: number };
	readonly beneficiary: { readonly id: number } | null;
	readonly interview: { readonly id: number } | null;
	readonly label: string;
	readonly kind: LabeledValuePayload;
	readonly launchMode: LabeledValuePayload;
	readonly status: LabeledValuePayload;
	readonly startedAt: string;
	readonly finishedAt: string | null;
	readonly stepCount: number;
	readonly focusStep: FacilityWorkflowRunFocusStepPayload | null;
	readonly handledAt: string | null;
	readonly handledBy: { readonly id: number } | null;
	readonly canChangeHandling: boolean;
};

export type FacilityWorkflowRunsFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly FacilityWorkflowRunPayload[];
};

export type FacilityWorkflowRunsFetchedAction = {
	type: 'FACILITY_WORKFLOW_RUNS_FETCHED';
	payload: FacilityWorkflowRunsFetchedPayload;
	facilityId: number;
	queryKey: string;
};

export default (
	payload: FacilityWorkflowRunsFetchedPayload,
	facilityId: number,
	queryKey: string,
): FacilityWorkflowRunsFetchedAction => ({
	type: 'FACILITY_WORKFLOW_RUNS_FETCHED',
	payload,
	facilityId,
	queryKey,
});
